module.exports = __webpack_public_path__ + "static/media/commercial-litigation-lion.57e3ac02.jpg";